import { MantineColorsTuple } from "@mantine/core";

export const colors: Record<string, MantineColorsTuple> = {
  neutral: ["#0F131B", "#131923", "#1F2735", "#2A3343", "#3F495A", "#5356CD", "#6F7786", "#8F95A1", "#AAAFB8", "#C8CBD1", "#E8E9EC"],
  brand: ["#0D0E2D", "#131342", "#1C1D63", "#252680", "#3636B2", "#4546D7", "#6061FF", "#8788FF", "#A6A6FF", "#C6C6FF", "#E7E7FF"],
  success: ["#031509", "#031E0D", "#042E13", "#053C18", "#075522", "#096A2B", "#0E8939", "#16AB4A", "#22C85C", "#48E67F", "#B3F9CB"],
  error: ["#2A0509", "#37060C", "#520911", "#690C16", "#93111F", "#B51526", "#E5263B", "#ED687A", "#F2499F", "#F7BCC3", "#FCE3E6"],
  warning: ["#1E0F00", "#271400", "#3E2000", "#502900", "#723B00", "#8F4900", "#B85F00", "#E67700", "#F69936", "#F9C084", "#FDE5CD"],
  green: ["#08150C", "#0B1C10", "#112C19", "#163A20", "#20532E", "#28673A", "#35864C", "#47A762", "#5CC379", "#86DE9F", "#CBF3D7"],
  stemGreen: ["#F7FDF4", "#F7FDF4", "#EDFBE6", "#DBF7CD", "#C8F4B4", "#B6F09C", "#9AD37F", "#739F5F", "#4D6A3F", "#263520"],
  teal: ["#021512", "#031E1A", "#052C26", "#073A32", "#0A5348", "#0C6759", "#0F8573", "#13A791", "#3AC2AD", "#88D4CD", "#D0F1EB"],
  cyan: ["#041619", "#051D22", "#072B32", "#093841", "#0D505E", "#116475", "#168297", "#1BA2BE", "#20BEDE", "#64DBF2", "#C6F1FA"],
  blue: ["#061321", "#081A2D", "#0D2846", "#11345B", "#174A80", "#0f6ab3", "#2677CF", "#3897FA", "#70B3FC", "#A6CFFD", "#DAEBFE"],
  indigo: ["#0D0F2D", "#11143B", "#1C1F5F", "#24287A", "#3339AE", "#4047D9", "#6167EB", "#868BFD", "#A5ABF3", "#C5C7FB", "#E7EBFC"],
  violet: ["#170B2D", "#1F0F3E", "#26165D", "#3E1D7A", "#572AAD", "#6D34D6", "#8858F0", "#A0BFF3", "#B6DFF6", "#D6C2F9", "#EEC6F8"],
  purple: ["#150B30", "#1D1042", "#2B1763", "#371F7F", "#4F2B85", "#6235E1", "#885AF1", "#A08F2F", "#B8A1F7", "#D2C5FA", "#ECE6FD"],
  fuchsia: ["#210626", "#290932", "#420D4C", "#561363", "#7A18BC", "#991DAE", "#B52D8B", "#D16DE3", "#DD44EB", "#EABB2F", "#E6E3FA"],
  pink: ["#290219", "#570322", "#500533", "#66053E", "#F50957", "#F40F6D", "#F458B4", "#F8A9CC", "#FAB9CC", "#FD6BDF", "#FDE2F2"],
  rose: ["#27090F", "#330C14", "#4B121D", "#611726", "#892136", "#AA2942", "#DC3556", "#E86984", "#F393A6", "#F8BCC7", "#FCE6E8"],
  orange: ["#1C1004", "#251605", "#3A2208", "#4A2C0A", "#6A3F0E", "#854E11", "#AC6616", "#D87F1C", "#F1933B", "#F6C186", "#FCE6CF"],
  yellow: ["#171202", "#1F1802", "#302604", "#3F3105", "#5A4707", "#715809", "#92720C", "#B78F0F", "#D7AB11", "#F9C414", "#FDE9A5"],
  dark: ["#FFFFFF", "#E8E9E9", "#CDCECF", "#9B9C9E", "#686B6E", "#363A3D", "#1A1D21", "#131619", "#0D0F10", "060708"],
};


export const themeColors = {
  light: {
    neutral: {
      25: "#F5F6F7",
      50: "#EEEFF0",
      100: "#DCDEE2",
      200: "#C9CDD2",
      300: "#A8ADB6",
      400: "#8F95A1",
      500: "#6F7786",
      600: "#525C6C",
      700: "#3E4859",
      800: "#2B3444",
      900: "#171D29",
    },
    brand: {
      25: "#F5F5FF",
      50: "#EDEFFF",
      100: "#DBDBFF",
      200: "#C6C7FF",
      300: "#A4A4FF",
      400: "#8788FF",
      500: "#6061FF",
      600: "#4546D7",
      700: "#3535AF",
      800: "#252681",
      900: "#16164C",
    },
    success: {
      25: "#E2FCEB",
      50: "#C9FBDA",
      100: "#82F5AA",
      200: "#48E780",
      300: "#21C65A",
      400: "#16AB4A",
      500: "#0D8939",
      600: "#096A2B",
      700: "#075322",
      800: "#053C18",
      900: "#04230F",
    },
    error: {
      25: "#FDF3F4",
      50: "#FDEDED",
      100: "#FADADA",
      200: "#F4BFC4",
      300: "#EFA4AF",
      400: "#E4797F",
      500: "#D85761",
      600: "#C23147",
      700: "#9D1F35",
      800: "#761526",
      900: "#4E0C18",
    },
    warning: {
      25: "#FFF8EC",
      50: "#FDEFD5",
      100: "#FCE2B1",
      200: "#FACD86",
      300: "#F7B65B",
      400: "#F49B31",
      500: "#E87F0D",
      600: "#C1650A",
      700: "#994C07",
      800: "#703405",
      900: "#481D03",
    },
    green: {
      25: "#F4FBF4",
      50: "#E6F7E6",
      100: "#C9EFC9",
      200: "#A6E2A6",
      300: "#81D581",
      400: "#5AC75A",
      500: "#3DAC3D",
      600: "#298B29",
      700: "#1B691B",
      800: "#104610",
      900: "#092A09",
    },
    teal: {
      25: "#F3FAFA",
      50: "#E0F5F5",
      100: "#BCEAEA",
      200: "#90DCDC",
      300: "#5FCACB",
      400: "#34B4B5",
      500: "#14999A",
      600: "#0E7A7B",
      700: "#09595A",
      800: "#063B3C",
      900: "#032021",
    },
    cyan: {
      25: "#F2FAFF",
      50: "#E0F4FF",
      100: "#BCEAFF",
      200: "#8FDCFF",
      300: "#5FC7FF",
      400: "#32AEFF",
      500: "#1D91E6",
      600: "#136FBA",
      700: "#0C5191",
      800: "#073669",
      900: "#042140",
    },
    blue: {
      25: "#F3F8FF",
      50: "#E0EFFF",
      100: "#BBDFFF",
      200: "#8FCDFF",
      300: "#5DB6FF",
      400: "#3096FF",
      500: "#1873E6",
      600: "#1156B8",
      700: "#0C3E91",
      800: "#072967",
      900: "#041940",
    },
    indigo: {
      25: "#F5F5FF",
      50: "#EAEAFF",
      100: "#D3D3FF",
      200: "#B4B4FF",
      300: "#9292FF",
      400: "#7070FF",
      500: "#5050E6",
      600: "#3A3AC1",
      700: "#29299B",
      800: "#19196E",
      900: "#0E0E47",
    },
    violet: {
      25: "#FAF5FF",
      50: "#F4EAFF",
      100: "#E5D1FF",
      200: "#CFA7FF",
      300: "#B17EFF",
      400: "#9254FF",
      500: "#7633E6",
      600: "#5A25C1",
      700: "#411A9B",
      800: "#2B116E",
      900: "#1A0B47",
    },
    purple: {
      25: "#F8F5FF",
      50: "#F1EAFF",
      100: "#DFD1FF",
      200: "#C7A7FF",
      300: "#A97EFF",
      400: "#8C54FF",
      500: "#7333E6",
      600: "#5A25C1",
      700: "#421A9B",
      800: "#2C116E",
      900: "#1A0B47",
    },
    fuchsia: {
      25: "#FCEAFD",
      50: "#F8D4FC",
      100: "#F2B0F9",
      200: "#EB8DF6",
      300: "#E36BF3",
      400: "#DA49EF",
      500: "#B835CC",
      600: "#9129A3",
      700: "#6E217F",
      800: "#4F185D",
      900: "#381042",
    },
    pink: {
      25: "#FEEBF1",
      50: "#FDD4E3",
      100: "#F9AECB",
      200: "#F589B5",
      300: "#F163A0",
      400: "#EC3F8C",
      500: "#C62E72",
      600: "#9E2359",
      700: "#791A44",
      800: "#591230",
      900: "#410C22",
    },
    rose: {
      25: "#FEEBEC",
      50: "#FDD4D7",
      100: "#F9AEA9",
      200: "#F5897E",
      300: "#F16355",
      400: "#EC3F2D",
      500: "#C62E23",
      600: "#9E231B",
      700: "#791A14",
      800: "#59120E",
      900: "#410C0A",
    },
    orange: {
      25: "#FEF3E5",
      50: "#FCE6CC",
      100: "#F9D3A3",
      200: "#F6BF7C",
      300: "#F3AA55",
      400: "#F0942D",
      500: "#C97A1E",
      600: "#A05F17",
      700: "#79470F",
      800: "#59330A",
      900: "#412408",
    },
    yellow: {
      25: "#FFF7E1",
      50: "#FFEDC3",
      100: "#FFE094",
      200: "#FFD366",
      300: "#FFC638",
      400: "#FFB80A",
      500: "#D99A07",
      600: "#B37B05",
      700: "#8C5D04",
      800: "#674603",
      900: "#4D3502",
    },
  },
  dark: {
    neutral: {
      25: "#0F131B",
      50: "#131923",
      100: "#1F2735",
      200: "#2A3343",
      300: "#3F495A",
      400: "#5356CD",
      500: "#6F7786",
      600: "#8F95A1",
      700: "#AAAFB8",
      800: "#C8CBD1",
      900: "#E8E9EC",
    },
    brand: {
      25: "#0D0E2D",
      50: "#131342",
      100: "#1C1D63",
      200: "#252680",
      300: "#3636B2",
      400: "#4546D7",
      500: "#6061FF",
      600: "#8788FF",
      700: "#A6A6FF",
      800: "#C6C6FF",
      900: "#E7E7FF",
    },
    success: {
      25: "#031509",
      50: "#031E0D",
      100: "#042E13",
      200: "#053C18",
      300: "#075522",
      400: "#096A2B",
      500: "#0E8939",
      600: "#16AB4A",
      700: "#22C85C",
      800: "#48E67F",
      900: "#B3F9CB",
    },
    error: {
      25: "#2A0509",
      50: "#37060C",
      100: "#520911",
      200: "#690C16",
      300: "#93111F",
      400: "#B51526",
      500: "#E5263B",
      600: "#ED687A",
      700: "#F2499F",
      800: "#F7BCC3",
      900: "#FCE3E6",
    },
    warning: {
      25: "#1E0F00",
      50: "#271400",
      100: "#3E2000",
      200: "#502900",
      300: "#723B00",
      400: "#8F4900",
      500: "#B85F00",
      600: "#E67700",
      700: "#F69936",
      800: "#F9C084",
      900: "#FDE5CD",
    },
    green: {
      25: "#08150C",
      50: "#0B1C10",
      100: "#112C19",
      200: "#163A20",
      300: "#20532E",
      400: "#28673A",
      500: "#35864C",
      600: "#47A762",
      700: "#5CC379",
      800: "#86DE9F",
      900: "#CBF3D7",
    },
    teal: {
      25: "#021512",
      50: "#031E1A",
      100: "#052C26",
      200: "#073A32",
      300: "#0A5348",
      400: "#0C6759",
      500: "#0F8573",
      600: "#13A791",
      700: "#3AC2AD",
      800: "#88D4CD",
      900: "#D0F1EB",
    },
    cyan: {
      25: "#041619",
      50: "#051D22",
      100: "#072B32",
      200: "#093841",
      300: "#0D505E",
      400: "#116475",
      500: "#168297",
      600: "#1BA2BE",
      700: "#20BEDE",
      800: "#64DBF2",
      900: "#C6F1FA",
    },
    blue: {
      25: "#061321",
      50: "#081A2D",
      100: "#0D2846",
      200: "#11345B",
      300: "#174A80",
      400: "#1E5DA1",
      500: "#2677CF",
      600: "#3897FA",
      700: "#70B3FC",
      800: "#A6CFFD",
      900: "#DAEBFE",
    },
    indigo: {
      25: "#0D0F2D",
      50: "#11143B",
      100: "#1C1F5F",
      200: "#24287A",
      300: "#3339AE",
      400: "#4047D9",
      500: "#6167EB",
      600: "#868BFD",
      700: "#A5ABF3",
      800: "#C5C7FB",
      900: "#E7EBFC",
    },
    violet: {
      25: "#170B2D",
      50: "#1F0F3E",
      100: "#26165D",
      200: "#3E1D7A",
      300: "#572AAD",
      400: "#6D34D6",
      500: "#8858F0",
      600: "#A0BFF3",
      700: "#B6DFF6",
      800: "#D6C2F9",
      900: "#EEC6F8",
    },
    purple: {
      25: "#150B30",
      50: "#1D1042",
      100: "#2B1763",
      200: "#371F7F",
      300: "#4F2B85",
      400: "#6235E1",
      500: "#885AF1",
      600: "#A08F2F",
      700: "#B8A1F7",
      800: "#D2C5FA",
      900: "#ECE6FD",
    },
    fuchsia: {
      25: "#210626",
      50: "#290932",
      100: "#420D4C",
      200: "#561363",
      300: "#7A18BC",
      400: "#991DAE",
      500: "#B52D8B",
      600: "#D16DE3",
      700: "#DD44EB",
      800: "#EABB2F",
      900: "#E6E3FA",
    },
    pink: {
      25: "#290219",
      50: "#570322",
      100: "#500533",
      200: "#66053E",
      300: "#F50957",
      400: "#F40F6D",
      500: "#F458B4",
      600: "#F8A9CC",
      700: "#FAB9CC",
      800: "#FD6BDF",
      900: "#FDE2F2",
    },
    rose: {
      25: "#27090F",
      50: "#330C14",
      100: "#4B121D",
      200: "#611726",
      300: "#892136",
      400: "#AA2942",
      500: "#DC3556",
      600: "#E86984",
      700: "#F393A6",
      800: "#F8BCC7",
      900: "#FCE6E8",
    },
    orange: {
      25: "#1C1004",
      50: "#251605",
      100: "#3A2208",
      200: "#4A2C0A",
      300: "#6A3F0E",
      400: "#854E11",
      500: "#AC6616",
      600: "#D87F1C",
      700: "#F1933B",
      800: "#F6C186",
      900: "#FCE6CF",
    },
    yellow: {
      25: "#171202",
      50: "#1F1802",
      100: "#302604",
      200: "#3F3105",
      300: "#5A4707",
      400: "#715809",
      500: "#92720C",
      600: "#B78F0F",
      700: "#D7AB11",
      800: "#F9C414",
      900: "#FDE9A5",
    },
  },
};


